<template>
  <BaseDialog :isOpen="isOpen" :width="1200">
    <template v-slot:title>
      Edit Language
    </template>
    <template v-slot:body>
      <LanguageDetailsForm
        ref="languageDetailsForm"
        :initialData="language"
        isEdit
      />
    </template>
    <template v-slot:actions>
      <PrimaryButton @click.native="close" text :disabled="isLoading">
        Cancel
      </PrimaryButton>
      <PrimaryButton @click.native="onSubmit" :loading="isLoading">
        Save Changes
      </PrimaryButton>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import LanguageDetailsForm from "@/views/profile/QuestionsAndAnswers/steps/LanguagesAndSkills/Languages/components/LanguageDetailsForm";
import { LANGUAGES_AND_SKILLS_NAMESPACE } from "@/store/modules/users/languagesAndSkills";
import { createNamespacedHelpers } from "vuex";
import { EDIT_USER_LANGUAGE } from "@/store/modules/users/languagesAndSkills/actions";
import { AUTH_NAMESPACE } from "@/store/modules/auth";

const { mapActions } = createNamespacedHelpers(LANGUAGES_AND_SKILLS_NAMESPACE);
const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  name: "EditLanguageDialog",
  components: {
    PrimaryButton,
    BaseDialog,
    LanguageDetailsForm
  },
  props: {
    language: Object,
    isOpen: Boolean
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    ...mapAuthState({
      self: state => state.userData
    })
  },
  methods: {
    ...mapActions({
      editUserLanguage: EDIT_USER_LANGUAGE
    }),
    close() {
      this.$emit("close");
    },
    async onSubmit() {
      const isValid = await this.$refs.languageDetailsForm.validate();
      if (isValid) {
        const language = this.$refs.languageDetailsForm.getData();
        this.isLoading = true;
        await this.editUserLanguage({
          userId: this.self.id,
          language: {
            ...language,
            languageId: language.id
          }
        });
        this.close();
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss"></style>
